import { Provider } from '@angular/core';

import { MotManageVacationsUseCasesImpl } from '@app/domain/use-cases/manage-vacations/mot/mot-manage-vacations.use-cases';
import { MOT_MANAGE_VACATIONS_USE_CASES } from '@app/domain/use-cases/manage-vacations/mot/mot-manage-vacations.use-cases.contract';

export const motManageVacationsUseCasesProvider: Provider = {
  provide: MOT_MANAGE_VACATIONS_USE_CASES,
  useClass: MotManageVacationsUseCasesImpl
};
